export default {
    FRAME_CLICK: 'FrameClick',
};
